import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Container,
  Content,
  ContentModal,
  HeaderModal,
  SubTitle,
  Title,
} from "./style";
import {
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  IconButton,
  ListItem,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import {
  FilterList,
  Close,
} from "@mui/icons-material";
import moment from "moment";
import { Error } from "../Error";
import { Header } from "../Header";
import { FilterForm } from "./FilterForm";
import { apiOperation, headers } from "../../services/api";
import { Loading } from "../Loading";
import { ETipoTransacao } from "../../models/enums/TipoTransacao";
import { Transacao } from "../../models/notouch/transacao";
import { ChipData, filters, IFilter } from "./models";
import { Conta } from "../../models/notouch/conta";
import { Resultado, Paginacao } from "../../models/base/basic";

export const Wallet = () => {
  const [transactionList, setTransactionList] = useState<Transacao[]>([]);
  const [balance, setBalance] = useState<number>(0);
  const navigate = useNavigate();
  const [dataFilter, setDataFilter] = useState<IFilter>({ ...filters });
  const [chipDataList, setChipDataList] = useState<ChipData[]>([]);
  const [showLoading, setShowLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [pagination, setPagination] = useState({
    paginaCorrente: 0,
    quantidadePaginas: 0,
    tamanhoPagina: 10,
    quantidadeRegistros: 0,
  });

  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [errorApi, setErrorApi] = useState({
    message: "",
    title: "",
    state: false,
  });

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const formatDateToISO = (date: any) => {
    const formated = date.split("/").reverse().join("-");
    return moment(formated).toISOString();
  };

  // INICIO FILTRO
  function searchFilter(item: any) {
    const listFilters: ChipData[] = [];
    Object.keys(item).forEach((key) => {
      if (item[key]) {
        listFilters.push({
          id: key,
          value: item[key],
        });
      }
    });
    setDataFilter({ ...item });
    setChipDataList(listFilters);
    setOpen(false);
    getHistorico(mountParams(item));
  }

  function deleteFilter(item: any) {
    if (item.id.includes("data")) {
      const newChipDataList = chipDataList.filter(
        (item) => !item.id.includes("data")
      );
      setChipDataList([...newChipDataList]);
      setDataFilter({ ...dataFilter, dataFinal: "", dataInicial: "" });
      searchFilter({ ...dataFilter, dataFinal: "", dataInicial: "" });
    } else {
      const index = chipDataList.findIndex((chip) => chip.id === item.id);
      chipDataList.splice(index, 1);
      setChipDataList([...chipDataList]);
      setDataFilter({ ...dataFilter, [item.id]: "" });
      searchFilter({ ...dataFilter, [item.id]: "" });
    }
  }

  const mountParams = (filter: IFilter) => {
    let str = "";
    if (filter.descricao) str += `&descricao=${filter.descricao}`;
    if (filter.tipo) str += `&tipo=${filter.tipo}`;
    if (filter.dataFinal) str += `&dataFinal=${formatDateToISO(filter.dataFinal)}`;
    if (filter.dataInicial) str += `&dataInicial=${formatDateToISO(filter.dataInicial)}`;
    return str;
  };
  // FIM FILTRO


  // INICIO PAGINAÇÃO
  const handleChangeRowsPerPage = (event: any) => {
    setRecordsPerPage(event.target.value);
    setPagination({
      ...pagination,
      paginaCorrente: 0,
      tamanhoPagina: event.target.value | 10,
    });
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPagination({
      ...pagination,
      paginaCorrente: newPage,
    });
  };
  // FIM PAGINAÇÃO

  const getHistorico = async (params = "") => {
    try {
      const config = {
        headers: headers()
      };
      setShowLoading(true);
      let urlString = `notouch/transacao/listar
				?pagina=${pagination.paginaCorrente + 1}
				&registrosPagina=${pagination.tamanhoPagina}`;

      urlString += params;

      const { data } = await apiOperation.get<Resultado<Paginacao<Transacao>>>(urlString, config);

      if (!data.erro) {
        setTransactionList([...data.valor.dados]);
        setPagination({
          ...pagination,
          quantidadePaginas: data.valor.quantidadePaginas,
          quantidadeRegistros: data.valor.quantidadeRegistros,
        });
        setShowLoading(false);
      } else {
        setErrorApi({
          title: "Não foi possivel se conectar a API no momento.",
          state: true,
          message: data.erros?.join("<hr />"),
        });
        setShowLoading(false);
      }
    } catch (error: any) {
      setErrorApi({
        title: `API Não disponivel`,
        message: `Caso o problema continue informe o seguinte erro: ${error?.response?.status}-${error?.response?.statusText}`,
        state: true,
      });
      setShowLoading(false);
    }
  }

  const getSaldo = async () => {
    try {
      const config = {
        headers: headers(),
      };
      setShowLoading(true);
      let urlString = `notouch/conta/obter`;

      const { data } = await apiOperation.get<Resultado<Conta>>(urlString, config);

      if (!data.erro) {
        setBalance(data.valor.saldo);  
        setShowLoading(false);
      } else {
        setErrorApi({
          title: "Não foi possivel se conectar a API no momento.",
          state: true,
          message: data.erros?.join("<hr />"),
        });
        setShowLoading(false);
      }
    } catch (error: any) {
      setErrorApi({
        title: `API Não disponivel`,
        message: `Caso o problema continue informe o seguinte erro: ${error?.response?.status}-${error?.response?.statusText}`,
        state: true,
      });
      setShowLoading(false);
    }
  }

  const formatTipoTransacao = (value: any) => {
    var tipo = ETipoTransacao[value as keyof typeof ETipoTransacao];
    var css = {
      backgroundColor: "var(--surface-sunken)",
      borderRadius: "15px",
      width: "fit-content",
      padding: "inherit",
      color: "var(--text-primary)",
      margin: "auto",
    };

    switch (tipo) {
      case ETipoTransacao.credito:
        return { ...css, backgroundColor: "var(--success-surface)", color: "var(--text-primary)" };
      case ETipoTransacao.debito:
        return { ...css, backgroundColor: "var(--error-surface)", color: "var(--text-primary)" };
      default:
        return { ...css };
    }
  }

  useEffect(() => {
    getSaldo();
    getHistorico();

  }, [pagination.paginaCorrente, pagination.tamanhoPagina]);

  return (
    <>
      <Header />
      <Container>
        <Content>
          <Title style={{fontSize: "50px"}}>Carteira</Title>
          <Content style={{ width: "280px" }}>
            <Button
              className={"buttonPesquisa"}
              onClick={() => navigate("/compra")}
            >
              Comprar Créditos
            </Button>
            <Content className={"cardSaldo"} style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "space-evenly" }}>
              <Title style={{margin: "0px", fontSize: "40px"}}>{balance}</Title>
              <SubTitle style={{margin: "0px", fontSize: "20px"}}>Créditos</SubTitle>
            </Content>
          </Content>
        </Content>
        <Card sx={{ minWidth: 275 }}>
          {showLoading ? (
            <Loading hidden={!showLoading} />
          ) : (
            <>
              <CardContent>
                <Box display={"flex"}>
                  <ListItem key={"data.key"}>
                    {chipDataList?.map((data) => (
                      <Chip
                        style={{ marginRight: "12px" }}
                        key={data.id}
                        label={data.value}
                        color="primary"
                        onDelete={() => deleteFilter(data)}
                      />
                    ))}
                  </ListItem>
                  <Button
                    style={{ width: "20%" }}
                    variant="outlined"
                    onClick={handleOpen}
                    startIcon={<FilterList />}
                  >
                    Filtrar Dados
                  </Button>
                </Box>
              </CardContent>
              <CardContent>
                <TableContainer>
                  <Table
                    sx={{ minWidth: 650 }}
                    size="small"
                    aria-label="a dense table"
                  >
                    <TableHead>
                      <TableRow>
                        
                        <TableCell style={{textAlign: "left", fontSize: "20px", fontWeight: "800", padding: "15px"}}>Descrição</TableCell>
                        <TableCell style={{textAlign: "center", fontSize: "20px", fontWeight: "800", padding: "15px"}}>Tipo</TableCell>
                        <TableCell style={{textAlign: "center", fontSize: "20px", fontWeight: "800", padding: "15px"}}>Data</TableCell>
                        <TableCell style={{textAlign: "center", fontSize: "20px", fontWeight: "800", padding: "15px"}}>Valor</TableCell>

                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {transactionList.map((item) => (
                        <TableRow
                        key={item.id}
                        sx={{"&:last-child td, &:last-child th": { border: 0 },}}
                        hover
                        >

                          <TableCell align="left" component="th" scope="row"> {item.descricao} </TableCell>

                          <TableCell align="center" style={{ whiteSpace: "break-spaces" }}>
                              <div style={formatTipoTransacao(item.tipo)} >
                                {ETipoTransacao[item.tipo as keyof typeof ETipoTransacao] ?? "N/D"}
                              </div>
                            </TableCell>

                          <TableCell align="center"> {moment(item.dataInclusao).format("DD/MM/YYYY HH:mm")} </TableCell>

                          <TableCell align="center"> {item.valor} </TableCell>
                  
                        </TableRow>
                      ))}
                      {transactionList.length === 0 && (
                        <TableRow>
                          <TableCell colSpan={5} align="center">
                            Nenhum registro encontrado
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                  <TablePagination
                    component="div"
                    count={pagination.quantidadeRegistros}
                    page={pagination.paginaCorrente}
                    onPageChange={handleChangePage}
                    rowsPerPage={recordsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    labelRowsPerPage={"Registros por página: "}
                  />
                </TableContainer>
              </CardContent>
            </>
          )}
        </Card>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <ContentModal>
            <HeaderModal>
              <SubTitle>Filtar Transações</SubTitle>
              <IconButton onClick={handleClose}>
                <Close />
              </IconButton>
            </HeaderModal>
            <Box>
              {
                <FilterForm
                  onSave={(event) => searchFilter(event)}
                  dataFilter={dataFilter}
                />
              }
            </Box>
          </ContentModal>
        </Modal>
        <Error
          hasOpen={errorApi.state}
          handleClose={() => setErrorApi({ ...errorApi, state: false })}
          errorMsg={errorApi.message}
          title={errorApi.title}
        />
      </Container>
    </>
  );
};
